import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { bindActionCreators } from 'redux';

import * as SsrActions from 'rebook/apps/base/actions/SsrActions';

import NavigationButton from './NavigationButton';
import PageButton from './PageButton';
import styles from './style.scss';


const handlePageChange = (onPageChange, pageNumber, history) => {
  window.scrollTo(0, 0);

  let searchParameters = queryString.parse(history.location.search);
  searchParameters.page = pageNumber;

  const search = queryString.stringify(searchParameters);

  history.push({
    ...history.location,
    search,
  });

  onPageChange(pageNumber);
};

const Ellipsis = () => (
  <button>...</button>
);

const ClosestPageRange = ({ currentPage, lastPage, onPageChange, history, navigationUrl }) => {
  let startPager = 1,
      showedButtons = 3;

  if (lastPage <= showedButtons) {
    showedButtons = lastPage;
  }

  else if (currentPage > (lastPage - showedButtons + 1)) {
    startPager = lastPage - showedButtons + 1;
  }
  else if (currentPage > showedButtons - 1) {
    startPager = currentPage - Math.ceil(showedButtons / 2) + 1;
  }

  let closestPages = [...Array(showedButtons)].map((e, i) => {
    return startPager + i;
  });

  return closestPages.map((pageNumber, i) => (
    <PageButton
      key={i}
      onClick={() => handlePageChange(onPageChange, pageNumber, history)}
      navigationUrl={navigationUrl(pageNumber)}
      pageNumber={pageNumber}
      disabled={pageNumber === currentPage} />
  ));
};

class ContextPagination extends React.Component {
  componentWillUnmount() {
    this.props.SsrActions.setQuery({ page: 1 });
  }

  render() {
    const { currentPage, lastPage, onPageChange, extraClassName, history } = this.props;
    const nextPage = currentPage + 1;
    const prevPage = currentPage - 1;

    if (lastPage <= 1) {
      return null;
    }

    const borderPage = 3;
    const navigationUrl = (pageNumber) => (`${this.props.location.pathname}?page=${pageNumber}`);

    return (
      <div className={classNames(styles.contextPagination, extraClassName)}>
        {/* Previous Page Arrow */}
        <NavigationButton
          type="prev"
          navigationUrl={currentPage === 1 ? navigationUrl(1) : navigationUrl(prevPage)}
          onClick={() => handlePageChange(onPageChange, prevPage, history)}
          disabled={currentPage === 1} />

        <div className={styles.pagesButtons}>
          {/* First Page Button */}
          {currentPage >= borderPage && borderPage !== lastPage && (
            <div className={styles.firstPage}>
              <PageButton
                navigationUrl={navigationUrl(1)}
                onClick={() => handlePageChange(onPageChange, 1, history)} />
              {currentPage >= (borderPage + 1) && (borderPage + 1) !== lastPage && <Ellipsis />}
            </div>
          )}

          {/* Buttons Range */}
          <div className={styles.pages}>
            <ClosestPageRange
              navigationUrl={navigationUrl}
              onPageChange={onPageChange}
              {...this.props} />
          </div>

          {/* Last Page Button */}
          {lastPage > borderPage && currentPage < lastPage - 1 && (
            <div className={styles.lastPage}>
              {currentPage < (lastPage - borderPage + 1) && (lastPage - borderPage) !== 1 && <Ellipsis />}
              <PageButton
                navigationUrl={navigationUrl(lastPage)}
                onClick={() => handlePageChange(onPageChange, lastPage, history)}
                pageNumber={lastPage} />
            </div>
          )}
        </div>

        {/* Next Page Arrow */}
        <NavigationButton
          type="next"
          navigationUrl={currentPage === lastPage ? navigationUrl(lastPage) : navigationUrl(nextPage)}
          onClick={() => handlePageChange(onPageChange, nextPage, history)}
          disabled={currentPage === lastPage} />
      </div>
    );
  };
}

ContextPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  lastPage: PropTypes.number.isRequired,
  extraClassName: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    SsrActions: bindActionCreators(SsrActions, dispatch),
  };
}

export default withRouter(connect(null, mapDispatchToProps)(ContextPagination));
